import { connect } from 'react-redux';

import { Creators as userActions } from 'Reducers/user';
import { Creators as transientActions } from 'Reducers/transient';
import { Creators as dailyFiguresActions } from 'Reducers/adminDailyFigures';

import AdminView from './view';

export default connect(
  state => ({
    ...state.adminOnboarding,
    adminDailyFigures: state.adminDailyFigures,
    adminFilters: state.user.adminFilters,
    application: state.application,
    dailyFigures: state.adminDailyFigures.dailyFigures,
    transient: state.transient,
    userAdminFilters: state.user.admin_filters,
    userRole: state.user.role_name,
    view: state.adminDailyFigures.view
  }),
  {
    getAdminDailyFigures: dailyFiguresActions.getAdminDailyFigures,
    resetTransient: transientActions.reset,
    updateDailyFiguresProps: dailyFiguresActions.updateProps,
    updateTransientProps: transientActions.updateProps,
    updateUserProps: userActions.updateProps
  }
)(AdminView);
